import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import Api from '../../utils/Api';
import UtilsTypes from './utils.types.js';
import MyCourseActionTypes from '../myCourse/myCourse.types';
import Loader from '../../utils/Loader';
import { getShowInstruction } from './utils.selectors';

function* setError(panelMsg, panelClass = 'alert alert-danger') {
	let errorPanel = {
		panelMsg,
		panelClass,
	};
	yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: errorPanel });

	Loader.hide();
}

function* testMicRecording({ payload }) {
	const showInstruction = yield select(getShowInstruction);
	try {
		const res = yield call(Api, {
			url: 'micTest',
			method: 'POST',
			data: payload,
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			Loader.hide();
			if (!!showInstruction) {
				document.getElementsByClassName('testing_mic_failed')[0].style.display =
					'block';
				document
					.getElementsByClassName('mic-icon')[0]
					.classList.add('disabledElement');
			} else {
				document.getElementById('failure_message').style.display = 'block';

				let myButtonClasses = document.getElementById('mic-icon').classList;
				myButtonClasses.remove('mic-flashing');
				myButtonClasses.remove('mic-flashing-rec');
				myButtonClasses.remove('mic-icon');
			}
		} else {
			Loader.hide();
			if (res.code === 200) {
				if (typeof res.data !== 'undefined' && res.data.mic_test_success) {
					Loader.show();
					yield call(setSpeechStatus);
				} else {
					if (!!showInstruction) {
						document.getElementsByClassName('testing_mic_failed')[0].style.display =
							'block';
					} else {
						document
							.getElementsByClassName('mic-icon')[0]
							.classList.add('disabledElement');
						document.getElementById('failure_message').style.display = 'block';

						var myButtonClasses = document.getElementById('mic-icon').classList;

						myButtonClasses.remove('mic-flashing');
						myButtonClasses.remove('mic-flashing-rec');
						myButtonClasses.remove('mic-icon');
					}
				}
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('utils', err);
	}
}

function* setSpeechStatus() {
	const showInstruction = yield select(getShowInstruction);
	try {
		const res = yield call(Api, {
			url: 'checkspeech',
			method: 'POST',
			data: {
				speech_is_on: 1,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				var elems = document.getElementsByClassName('modal-backdrop');
				for (var k = elems.length - 1; k >= 0; k--) {
					var parent = elems[k].parentNode;
					parent.removeChild(elems[k]);
				}

				if (!!showInstruction) {
					document.getElementsByClassName('testing_mic_success')[0].style.display =
						'block';
					yield put({
						type: MyCourseActionTypes.SET_SHOW_TESTINSTRUCTION,
						payload: true,
					});
				} else {
					yield put({ type: UtilsTypes.POST_SPEECH_STATUS.SUCCESS, payload: true });
					//window.location.reload();
					if(localStorage.getItem('disableTemplate') == 1)
					{
						window.location.href = localStorage.getItem("uap_returnPath");
					} else {
						window.location.reload();
					}
				}
			} else {
				yield call(setError, res.message);
				yield put({ type: UtilsTypes.POST_SPEECH_STATUS.SUCCESS, payload: false });
			}
		}
	} catch (err) {
		console.log('utils', err);
	}
}

function* testMicRecordingWatcher() {
	yield takeLatest(UtilsTypes.MIC_TEST_RECORDING.PENDING, testMicRecording);
}

function* setSpeechStatusWatcher() {
	yield takeLatest(UtilsTypes.POST_SPEECH_STATUS.PENDING, setSpeechStatus);
}

export function* utilsSagas() {
	yield all([call(testMicRecordingWatcher), call(setSpeechStatusWatcher)]);
}
